import { Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DownloadService } from 'src/app/shared/services/downloads/download.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { ScoreSearchBarComponent } from '../score-search-bar/score-search-bar.component';
import { ScoreDropdownMenuComponent } from '../score-dropdown-menu/score-dropdown-menu.component';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { environment } from 'src/environments/environment';
import { NgStyle, NgIf } from '@angular/common';
import { ScoreWidgetComponent } from '../score-widget/score-widget.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { LtmsErrorComponent } from '../../ltms-error/ltms-error.component';
import { ScoreTableComponent } from '../score-table/score-table.component';
import { ScoreComparisonToggleComponent } from '../score-comparison-toggle/score-comparison-toggle.component';
import {
  attachMetricDeviations,
  attachRatingResultDeviations,
  attachSelectionOptionDeviations,
  attachWeightageDeviation,
  getComparisonDetailedRatingResult,
  getComparisonPeriodLabel,
  getShowComparisonFlag,
  isComparisonAvailable,
  setShowComparisonFlag,
  shapeDistributionAsRatingResult,
  shouldShowDeviation,
} from 'src/app/shared/utils/score-deviation.util';
import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';
@Component({
    selector: 'app-score-comparison',
    templateUrl: './score-comparison.component.html',
    styleUrl: './score-comparison.component.scss',
    imports: [
        NgStyle,
        ScoreDropdownMenuComponent,
        ScoreWidgetComponent,
        ScoreSearchBarComponent,
        NgIf,
        LtmsLoaderComponent,
        LtmsErrorComponent,
        ScoreTableComponent,
        ScoreComparisonToggleComponent,
    ]
})
export class ScoreComparisonComponent implements OnInit, OnDestroy {
  @ViewChildren(ScoreSearchBarComponent) children: QueryList<ScoreSearchBarComponent> | undefined;
  @ViewChildren(ScoreDropdownMenuComponent) dropdownChildren: QueryList<ScoreDropdownMenuComponent> | undefined;
  mainDiscription: string = 'Compare performance score distribution across different dimensions (e.g., Hierarchy, Cohorts) in a side-by-side view to identify key differences and trends for deeper insights.';
  isHideClearAllSelection: boolean = true;

  // Compare dropdown
  compareDropdown: any = {
    config: {
      'width': '280px',
      'tab': 'comparision'
    },
    selectedOption: 'Select',
    options: []
  };
  selectedOption: string = '';
  widgetTool: any = {
    isDownloadButtonShow: true,
  };
  compareDropdownFieldId: any = '';

  tabelDropdownRawData: any = {};
  questionIds: any = [];
  payload: any = {};

  // Distribution
  distributionDropdown: any = {
    config: {
        'width': '180px',
        'isDisabled': true,
        'tab': 'comparision'
    },
    selectedOption: 'Select',
    options: []
  };
  distributionSearchPlaceHolder: string = '';
  isEmptyCardShow: boolean = true;
  isCardOneLoading: boolean = true;
  distributionTable: any = {
    tablePlugins: {
      isTableResize: false,
      deviationAlignment: true,
      alignAllDeviationColumns: true,
    },
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  searchDistributionText: string = '';
  selectedDistributionOption: string = '';
  distributionFieldId: any = '';
  distributionFieldType: any = '';
  
  // Compare With
  compareWithDropdown: any = {
    config: {
        'width': '180px',
        'isDisabled': true,
        'tab': 'comparision'
    },
    selectedOption: 'Select',
    options: []
  };
  compareWithSearchPlaceHolder: string = '';
  isCardTwoLoading: boolean = true;
  comapreWithTable: any = {
    tablePlugins: {
      isTableResize: false,
      deviationAlignment: true,
      alignAllDeviationColumns: true,
    },
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  searchcompareWithText: string = '';
  selectedCompareWithOption: string = '';
  compareWithFieldId: any = '';
  compareWithFieldType: any = '';

  // Prevention
  hierarchyStackCahcePre: any = {};
  hierarchyStackCahceCur: any = {};
  isReset: boolean = false;

  // Download
  downloadThroughAPIDistribution: boolean = false;
  downloadThroughAPICompareWith: boolean = false;
  tableFooterDataCache: any = {};
  tableFooterPreviousCache: any = null;
  lastDistributionSummaryCache: any = null;
  lastCompareWithSummaryCache: any = null;
  overallTotal: number = 0;
  previousOverallTotal: number = 0;
  isCardOneError: boolean = false;
  isCardTwoError: boolean = false;
  showComparisonFlag: boolean = false;
  isComparisonAvailable: boolean = true;
  dateType: string = '';
  comparisonPeriodLabel: string = '';

  onShowComparisonChange(checked: boolean): void {
    this.showComparisonFlag = checked;
    setShowComparisonFlag(checked);
  }

  private refreshComparisonLabels(): void {
    this.dateType =
      _.get(Helpers, 'datePicker.trendType') ||
      _.get(Helpers, 'datePicker.selectedTrend') ||
      'period';
    this.comparisonPeriodLabel = getComparisonPeriodLabel();
    this.isComparisonAvailable = isComparisonAvailable();
    if (!this.isComparisonAvailable) {
      this.showComparisonFlag = false;
      setShowComparisonFlag(false);
    } else {
      this.showComparisonFlag = getShowComparisonFlag();
    }
  }

  private attachRowDeviationsFromComparisonBucket(rowObj: any, bucket: any, detailedFeedbackItems: any): void {
    if (!bucket || !detailedFeedbackItems) {
      return;
    }
    try {
      const fieldId = this.compareDropdownFieldId;
      const questionType = detailedFeedbackItems?.type;
      const currentOverall = this.overallTotal ?? 0;
      const previousOverall = this.previousOverallTotal ?? 0;

      if (questionType === 'rating') {
        const { current, previous } = getComparisonDetailedRatingResult(bucket, fieldId);
        const scalerRaterType = detailedFeedbackItems?.scale_rater_type;
        const getBands = (type: string) => this.responseAnalyticsService.getRatingBandsByRaterType(type);
        attachRatingResultDeviations(rowObj, current, previous, scalerRaterType, getBands);
        attachWeightageDeviation(
          rowObj,
          current?.doc_count || 0,
          previous?.doc_count || 0,
          currentOverall,
          previousOverall
        );
      } else if (questionType === 'single-select') {
        const { current, previous } = getComparisonDetailedRatingResult(bucket, fieldId);
        const currentResponses = current?.doc_count || 0;
        const previousResponses = previous?.doc_count || 0;
        attachMetricDeviations(
          rowObj,
          { responses: currentResponses, rating: 0 },
          { responses: previousResponses, rating: 0 },
          { responses: 'responses' }
        );
        attachWeightageDeviation(rowObj, currentResponses, previousResponses, currentOverall, previousOverall);
        attachSelectionOptionDeviations(rowObj, current, previous, detailedFeedbackItems?.prop);
      } else if (questionType === 'multi-select') {
        const { current, previous } = getComparisonDetailedRatingResult(bucket, fieldId);
        const currentResponses = current?.doc_count || 0;
        const previousResponses = previous?.doc_count || 0;
        attachMetricDeviations(
          rowObj,
          { responses: currentResponses, rating: 0 },
          { responses: previousResponses, rating: 0 },
          { responses: 'responses' }
        );
        attachWeightageDeviation(rowObj, currentResponses, previousResponses, currentOverall, previousOverall);
        this.attachMultiSelectOptionDeviations(rowObj, bucket);
      } else if (questionType === 'text') {
        const currentDist =
          bucket?.primary_rating_distribution ?? bucket?.current?.primary_rating_distribution;
        const previousDist = bucket?.previous?.primary_rating_distribution;
        const primaryRatingItem = _.find(Helpers?.brandDetails?.detailed_feedback_items, {
          field_id: 'primary_rating',
        });
        const scalerRaterType = primaryRatingItem?.scale_rater_type;
        const getBands = (type: string) => this.responseAnalyticsService.getRatingBandsByRaterType(type);
        const currentShaped = shapeDistributionAsRatingResult(currentDist);
        const previousShaped = shapeDistributionAsRatingResult(previousDist);
        attachRatingResultDeviations(rowObj, currentShaped, previousShaped, scalerRaterType, getBands);
        attachWeightageDeviation(
          rowObj,
          currentShaped?.doc_count || 0,
          previousShaped?.doc_count || 0,
          currentOverall,
          previousOverall
        );
      }
    } catch (error) {
      console.error('Error attaching comparison row deviations:', error);
    }
  }

  private attachMultiSelectOptionDeviations(rowObj: any, bucket: any): void {
    const groupFieldId = this.compareDropdownFieldId;
    const subFields =
      Helpers?.brandDetails?.detailed_feedback_items?.filter((item: any) => item?.group_id === groupFieldId) || [];
    subFields.forEach((item: any) => {
      const possibleValue = item?.possible_values?.[0];
      if (possibleValue == null || possibleValue === '') {
        return;
      }
      const currentCount =
        bucket?.detailed_rating_by_type?.[item.field_id]?.rating_number?.[possibleValue] ?? 0;
      const previousCount =
        bucket?.previous?.detailed_rating_by_type?.[item.field_id]?.rating_number?.[possibleValue] ?? 0;
      if (typeof Helpers !== 'undefined' && Helpers.getFieldDeviation) {
        const deviation = Helpers.getFieldDeviation(currentCount, previousCount ?? 0);
        if (shouldShowDeviation(deviation)) {
          if (!rowObj.deviations) {
            rowObj.deviations = {};
          }
          rowObj.deviations[possibleValue] = deviation;
        }
      }
    });
  }

  private computeOverallTotalFromFooterCache(cache: any, detailedFeedbackItems: any): number {
    if (!cache || !detailedFeedbackItems) {
      return 0;
    }
    const result = _.get(cache?.detailed_rating_by_type, this.compareDropdownFieldId, null);
    let calculatedResult: any = {};
    if (detailedFeedbackItems?.type === 'rating') {
      calculatedResult = this.getResultForRatingType(
        result,
        detailedFeedbackItems?.main_rater_type,
        detailedFeedbackItems?.scale_rater_type,
        detailedFeedbackItems?.is_primary_rating
      );
    } else if (detailedFeedbackItems?.type === 'single-select') {
      calculatedResult = this.getResultForSelectionBasedType(result, '', 'single-select');
    } else if (detailedFeedbackItems?.type === 'multi-select') {
      calculatedResult = this.getResultForSelectionBasedType(result, cache, 'multi-select');
    } else if (detailedFeedbackItems?.type === 'text') {
      calculatedResult = this.getResultForTextType(cache?.primary_rating_distribution);
    }
    const formatted = calculatedResult?.responses ?? 0;
    return parseInt(String(formatted).replace(/,/g, ''), 10) || 0;
  }

  clickOnClearAllSelections(): void {
    if(this.isReset === false) {
      return;
    }
    this.isReset = false;
    this.compareDropdown = {
      config: {
        'tab': 'comparision'
      },
      selectedOption: 'Select',
      options: []
    };
    this.prepareCompareDropdown();
    this.selectedOption = '';
    if(this.dropdownChildren) {
      this.dropdownChildren.toArray()[0].selectedOption = 'Select';
      this.dropdownChildren.toArray()[1].selectedOption = 'Select';
      this.dropdownChildren.toArray()[2].selectedOption = 'Select';
    }
    this.distributionDropdown = {
      config: {
        'width': '180px',
        'isDisabled': true,
        'tab': 'comparision'
      },
      selectedOption: 'Select',
      options: []
    };
    this.compareWithDropdown = {
      config: {
        'width': '180px',
        'isDisabled': true,
        'tab': 'comparision'
      },
      selectedOption: 'Select',
      options: []
    };
    this.isHideClearAllSelection = true;
    this.distributionSearchPlaceHolder = '';
    this.compareWithSearchPlaceHolder = '';
    this.clearSearch('both');
    this.isEmptyCardShow = true;
    this.compareWithFieldId = '';
    this.isCardOneError = false;
    this.isCardTwoError = false;
  }

  private clearSearch(cardType: string): void {
    if(cardType === 'both') {
      if(this.children) {
        this.children.toArray().forEach(child => {
          child.clearSearch();
        });
      };
    } else if(cardType === 'distribution') {
      if(this.children) {
        this.children.toArray()[0].clearSearch();
      };
    } else if(cardType === 'compareWith') {
      if(this.children) {
        this.children.toArray()[1].clearSearch();
      };
    }
  }

  dropdownOptionChange(event: any, cardType: string): void {
    if(cardType === 'comparision') {
      this.questionIds = event?.question_ids
      this.selectedOption = event?.name || '';
      this.distributionDropdown.config.isDisabled = false;
      const textFilterData = this.tabelDropdownRawData.filter(item => item.category == "Text");
      if(event?.type === 'text' && textFilterData.length == 0) {
        this.resetComponent(event?.type);
      } else if(textFilterData.length > 0 && event?.type != 'text') {
        this.resetComponent(event?.type);
      }
      this.distributionDropdown.options = this.tabelDropdownRawData.filter(item => item.field_id !== this.compareWithFieldId);
      this.clearSearch('both');
      this.compareDropdownFieldId = event?.field_id || '';
      this.callApi('overall');
      if(this.distributionSearchPlaceHolder !== '') {
        this.callApi('distribution');
      }
      if(this.compareWithSearchPlaceHolder !== '') {
        this.callApi('compareWith');
      }
    } else if(cardType === 'distribution') {
      this.compareWithDropdown.options = this.tabelDropdownRawData.filter(item => item.field_id !== event?.field_id);
      this.compareWithDropdown.config.isDisabled = false;
      this.distributionSearchPlaceHolder = 'By ' + event?.name || '';
      this.isReset = true;
      this.isEmptyCardShow = false;
      this.isHideClearAllSelection = false;
      this.selectedDistributionOption = event?.name || '';
      this.distributionFieldId = event?.field_id;
      this.distributionFieldType = event?.field_type;
      this.callApi('distribution');
      this.clearSearch('distribution');
    } else if(cardType === 'compareWith') {
      this.distributionDropdown.options = this.tabelDropdownRawData.filter(item => item.field_id !== event?.field_id);
      this.compareWithSearchPlaceHolder = 'By ' + event?.name || '';
      this.clearSearch('compareWith');
      this.selectedCompareWithOption = event?.name || '';
      this.compareWithFieldId = event?.field_id;
      this.compareWithFieldType = event?.field_type;
      this.callApi('compareWith');
    }
    this.prepareTableHeader();
  }

  private resetComponent(eventType: string): void {
    this.isReset = false;
    this.isHideClearAllSelection = true;
    this.prepareCategoryDropdown();
    if(eventType === 'text') {
      this.tabelDropdownRawData.unshift(
        {name: 'Key Word', field_id: 'unigrams', field_type: 'comments', category: 'Text'},
        {name: 'Key Phrases', field_id: 'bigrams', field_type: 'comments', category: 'Text'},
      );
      if(Helpers?.brandDetails?.text_analytics?.is_enabled) {
        this.tabelDropdownRawData.unshift(
          {name: 'Category', field_id: 'level_0', field_type: 'text', category: 'Text'},
          {name: 'Sub Category', field_id: 'level_1', field_type: 'text', category: 'Text'},
        )
      }
    } else {
      let filterTabelDropdownRawData = this.tabelDropdownRawData.filter(item => item.category !== 'Text');
      this.tabelDropdownRawData = filterTabelDropdownRawData;
    }
    if(this.dropdownChildren) {
      this.dropdownChildren.toArray()[1].selectedOption = 'Select';
      this.dropdownChildren.toArray()[2].selectedOption = 'Select';
    }
    this.distributionDropdown.options = this.tabelDropdownRawData;
    this.compareWithDropdown = {
      config: {
        'width': '180px',
        'isDisabled': true,
        'tab': 'comparision'
      },
      selectedOption: 'Select',
      options: []
    };
    this.distributionSearchPlaceHolder = '';
    this.compareWithSearchPlaceHolder = '';
    this.clearSearch('both');
    this.isEmptyCardShow = true;
    this.compareWithFieldId = '';
    this.isCardOneError = false;
    this.isCardTwoError = false;
  }

  onSearch(event: string, type: string): void {
    if(type === 'distribution') {
      this.searchDistributionText = event;
      const searchResult = _.filter(this.distributionTable?.tableRow, row => 
        row.name.toLowerCase().includes(event.toLowerCase())
      );
      if(searchResult.length == 0) {
        this.isCardOneError = true;
      } else {
        this.isCardOneError = false;
      }
    } else if(type === 'compareWith') {
      this.searchcompareWithText = event;
      const searchResult = _.filter(this.comapreWithTable?.tableRow, row => 
        row.name.toLowerCase().includes(event.toLowerCase())
      );
      if(searchResult.length == 0) {
        this.isCardTwoError = true;
      } else {
        this.isCardTwoError = false;
      }
    }
  }

  private destroy$ = new Subject<void>();

  constructor(
    private responseAnalyticsService: ResponseAnalyticsService,
    private helpersService: HelpersService,
    private downloadService: DownloadService, 
    private toastService: ToastService,
    private UtilsService: UtilsService
  ) {}
  
  ngOnInit(): void {
    this.prepareCompareDropdown();
    this.prepareCategoryDropdown();
    this.refreshComparisonLabels();
    this.helpersService.appState.pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response && response.pending === false) {
        this.refreshComparisonLabels();
        this.hierarchyStackCahcePre = this.hierarchyStackCahceCur;
        this.hierarchyStackCahceCur = response?.hierarchyStack;
        let isHierarchyStackChange = _.isEqual(this.hierarchyStackCahcePre, this.hierarchyStackCahceCur);
        if(!isHierarchyStackChange) {
          this.isReset = true;
          this.clickOnClearAllSelections();
          this.prepareCategoryDropdown();
          this.callApi('overall');
        } else {
          this.clearSearch('both');
          if(this.compareDropdownFieldId !== '') {
            this.callApi('overall');
          }
          if(this.distributionSearchPlaceHolder !== '') {
            this.callApi('distribution');
          }
          if(this.compareWithSearchPlaceHolder !== '') {
            this.callApi('compareWith');
          }
        }
      }
    })
  }

  private callApi(type: string): void {
    this.payload = {
      brand_id: _.get(Helpers, 'brandDetails._id', null),
      date_filter_type: _.get(Helpers, 'datePicker.dateFilterType', 1),
      from: _.get(Helpers, 'datePicker.startDate', null),
      to: _.get(Helpers, 'datePicker.endDate', null),
      hierarchy_stack: _.get(Helpers, 'hierarchyStack', null),
      is_custom_date_range_selected: _.get(Helpers, 'datePicker.isCustomDateRangeSelected', false),
      main_rater_type: _.get(Helpers, 'brandDetails.main_rater_type', 2),
      manager_type: 2,
      question_aggs: true,
      view_type: 'list',
      size: 100,
      shop_id_list: [],
      universal_filter: _.get(Helpers, 'universalFilter', null),
      group_alias_key: this.getGroupAliasKey(),
    };
    if(this.questionIds) {
      this.payload['question_ids'] = this.questionIds;
    }
    if(type === 'distribution') {
      this.isCardOneLoading = true;
      this.isCardOneError = false;
      this.payload['field_id'] = this.distributionFieldId;
      this.payload['field_type'] = this.distributionFieldType === 'hierarchy' ? 'hierarchy' : this.distributionFieldType === 'response' ? 'response' : this.distributionFieldType === 'comments' ? 'comments' : 'tag'; //comments
      if(this.distributionFieldType === 'response') {
        let {fieldSubType, possibleValues} = this.preparePossibleValueAndFieldSubType(this.distributionFieldId);
        if(fieldSubType) {
          this.payload['field_sub_type'] = fieldSubType;
        }
        if(possibleValues && possibleValues.length > 0) {
          this.payload['possible_values'] = possibleValues;
        }
      }
    } else if(type === 'compareWith') {
      this.isCardTwoLoading = true;
      this.isCardTwoError = false;
      this.payload['field_id'] = this.compareWithFieldId;
      this.payload['field_type'] = this.compareWithFieldType === 'hierarchy' ? 'hierarchy' : this.compareWithFieldType === 'response' ? 'response' : this.compareWithFieldType === 'comments' ? 'comments' : 'tag';
      if(this.compareWithFieldType === 'response') {
        let {fieldSubType, possibleValues} = this.preparePossibleValueAndFieldSubType(this.compareWithFieldId);
        if(fieldSubType) {
          this.payload['field_sub_type'] = fieldSubType;
        }
        if(possibleValues && possibleValues.length > 0) {
          this.payload['possible_values'] = possibleValues;
        }
      }
    } else if(type === 'overall' && this.compareDropdownFieldId !== '') {
      this.payload['field_id'] = 'overall';
      this.payload['view_type'] = 'overall';
      this.payload['field_type'] = 'overall';
      this.payload['size'] = null;
    }
    this.payload = _.omitBy(this.payload, _.isNil);
    if(this.payload['field_id'] && this.payload['field_type']) {
      this.applyComparisonApiDateRange(this.payload);
      this.responseAnalyticsService.getcomparisonV2Data(this.payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
        if(response?.message === 'Success') {
          if(type === 'distribution') {
            this.lastDistributionSummaryCache = response?.data?.RatingsSummary;
            this.prepareDistributionTable(this.lastDistributionSummaryCache);
          } else if(type === 'compareWith') {
            this.lastCompareWithSummaryCache = response?.data?.RatingsSummary;
            this.prepareCompareWithTable(this.lastCompareWithSummaryCache);
          } else if(type === 'overall') {
            this.tableFooterDataCache = response?.data?.feed_details?.current;
            this.tableFooterPreviousCache = response?.data?.feed_details?.previous ?? null;
            this.prepareTableFooter();
          }
        }
      })
    }
  }
  private DisableSortingTable(cardName: string): void {
    if (cardName === 'compareWith') {
      this.comapreWithTable.tableHeader = this.comapreWithTable?.tableHeader?.map(item => ({
        ...item,
        isSorting: false
      }));
    }
    if (cardName === 'distribution') {
      this.distributionTable.tableHeader = this.distributionTable?.tableHeader?.map(item => ({
        ...item,
        isSorting: false
      }));
    }
  }

  private preparePossibleValueAndFieldSubType(appliedFieldId: any): any {
    let fieldSubType: any = '';
    let possibleValues: any = [];
    let brandDetailFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
    if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
      let brandDetailFeedbackItem: any = _.find(brandDetailFeedbackItems, (item: any) => item?.field_id === appliedFieldId);
      fieldSubType = brandDetailFeedbackItem?.type || null;
      if(brandDetailFeedbackItem && brandDetailFeedbackItem?.type == 'multi-select') {
        let brandGroupId: any =  _.filter(brandDetailFeedbackItems, (item: any) => item?.group_id === appliedFieldId);
        possibleValues = [];
        _.forEach(brandGroupId, (item: any) => {
          possibleValues.push({field_id: item?.field_id, value: item?.value});              
        });
      } else if(brandDetailFeedbackItem && brandDetailFeedbackItem?.type == 'text') {
        possibleValues = _.find(brandDetailFeedbackItems, (item: any) => item?.field_id === 'primary_rating')?.possible_values;
      } else {
        possibleValues = brandDetailFeedbackItem?.possible_values || null;
      }
    }
    return {
      fieldSubType: fieldSubType,
      possibleValues: possibleValues
    }
  }

  private prepareDistributionTable(data: any): void {
    let isResponseFieldType = this.distributionFieldType;
    let brandDetailFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
    const detailedFeedbackItems = _.find(Helpers?.brandDetails?.detailed_feedback_items, { field_id: this.compareDropdownFieldId });
    this.distributionTable.tableRow = [];
    let rowData: any = [];
    if(detailedFeedbackItems?.type === 'rating') {
      for(let key in data) {
        const result = _.get(data[key].detailed_rating_by_type, this.compareDropdownFieldId, null);
        let rowObj: any = {
          ...this.getResultForRatingType(result, detailedFeedbackItems?.main_rater_type, detailedFeedbackItems?.scale_rater_type, detailedFeedbackItems?.is_primary_rating)
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.distributionFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    } else if(detailedFeedbackItems?.type === 'single-select') {
      for(let key in data) {
        const result = _.get(data[key].detailed_rating_by_type, this.compareDropdownFieldId, null);
        let rowObj: any = {
          ...this.getResultForSelectionBasedType(result, '', 'single-select')
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.distributionFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    } else if(detailedFeedbackItems?.type === 'multi-select') {
      for(let key in data) {
        const result = _.get(data[key].detailed_rating_by_type, this.compareDropdownFieldId, null);
        let rowObj: any = {
          ...this.getResultForSelectionBasedType(result, data[key], 'multi-select')
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.distributionFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    } else if(detailedFeedbackItems?.type === 'text') {
      for(let key in data) {
        let rowObj: any = {
          ... this.getResultForTextType(data[key]?.primary_rating_distribution)
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.distributionFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    }
    if(rowData.length === 100) {
      this.DisableSortingTable('distribution')
      this.downloadThroughAPIDistribution = true;
      Helpers.smallAlertBox("Warning", 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', "warn", 5000);
    } else {
      this.downloadThroughAPIDistribution = false;
    }
    this.distributionTable.tableRow = rowData;
    this.isCardOneLoading = false;
    if(rowData.length == 0) {
      this.isCardOneError = true;
    } else {
      this.isCardOneError = false;
    }
  }

  private prepareCompareWithTable(data: any): void {
    let isResponseFieldType = this.compareWithFieldType;
    let brandDetailFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
    const detailedFeedbackItems = _.find(Helpers?.brandDetails?.detailed_feedback_items, { field_id: this.compareDropdownFieldId });
    this.comapreWithTable.tableRow = [];
    let rowData: any = [];
    if(detailedFeedbackItems?.type === 'rating') {
      for(let key in data) {
        const result = _.get(data[key].detailed_rating_by_type, this.compareDropdownFieldId, null);
        let rowObj: any = {
          ...this.getResultForRatingType(result, detailedFeedbackItems?.main_rater_type, detailedFeedbackItems?.scale_rater_type, detailedFeedbackItems?.is_primary_rating)
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.compareWithFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    } else if(detailedFeedbackItems?.type === 'single-select') {
      for(let key in data) {
        const result = _.get(data[key].detailed_rating_by_type, this.compareDropdownFieldId, null);
        let rowObj: any = {
          ...this.getResultForSelectionBasedType(result, '', 'single-select')
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.compareWithFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    } else if(detailedFeedbackItems?.type === 'multi-select') {
      for(let key in data) {
        const result = _.get(data[key].detailed_rating_by_type, this.compareDropdownFieldId, null);
        let rowObj: any = {
          ...this.getResultForSelectionBasedType(result, data[key], 'multi-select')
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.compareWithFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    } else if(detailedFeedbackItems?.type === 'text') {
      for(let key in data) {
        let rowObj: any = {
          ... this.getResultForTextType(data[key]?.primary_rating_distribution)
        };
        let responseWithComma: string = rowObj?.responses || '0';
        let response = parseInt(responseWithComma.replace(/,/g, ''), 10);
        rowObj.weightage = this.overallTotal > 0 ? ((response / this.overallTotal)*100).toFixed(1).endsWith('.0') ? Math.floor((response / this.overallTotal)*100) : ((response / this.overallTotal)*100).toFixed(1) : 0;
        if(rowObj.responses != 0) {
          if(isResponseFieldType === 'response') {
            rowObj.name = this.questionLabelMapper(this.compareWithFieldId, key);
          } else if(isResponseFieldType === 'interaction') {
            let questionName: any = '';
            if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
              let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id == key)[0];
              if(filterdObject?.question) {
                questionName = filterdObject?.question;
              } else {
                questionName = filterdObject?.text;
              }
            }
            rowObj.name = questionName || key;
          } else {
            rowObj.name = key;
          }
          this.attachRowDeviationsFromComparisonBucket(rowObj, data[key], detailedFeedbackItems);
          rowData.push(rowObj);
        }
      }
    }
    if(rowData.length === 100) {
      this.DisableSortingTable('compareWith');
      this.downloadThroughAPICompareWith = true;
      Helpers.smallAlertBox("Warning", 'More than 100 results found in the table for the current selection of the filters, sort is unavailable. Please download the data to view the entire range.', "warn", 5000);
    } else {
      this.downloadThroughAPICompareWith = false;
    }
    this.comapreWithTable.tableRow = rowData;
    this.isCardTwoLoading = false;
    if(rowData.length == 0) {
      this.isCardTwoError = true;
    }
  }

  private questionLabelMapper(appliedFieldId, keyName): any {
    let rowObjName: string = '';
    let brandDetailFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
    const fieldDefinitionOfFieldId: any = Helpers?.brandDetails?.field_definitions.find(item => item.field_id === appliedFieldId);
    if(brandDetailFeedbackItems && brandDetailFeedbackItems.length > 0) {
      let brandDetailFeedbackItem: any = _.find(brandDetailFeedbackItems, (item: any) => item?.field_id === appliedFieldId);
      if(brandDetailFeedbackItem && brandDetailFeedbackItem?.type == 'multi-select') {
        let brandGroupId: any =  _.filter(brandDetailFeedbackItems, (item: any) => item?.group_id === appliedFieldId);
        rowObjName = _.find(brandGroupId, (item: any) => item.value == keyName)?.text;
      } else if(brandDetailFeedbackItem && brandDetailFeedbackItem?.type == 'text') {
        // Need to implement later, need modification in API
      } else {
        let ratingTypeProp = brandDetailFeedbackItem?.prop;
        let brandDetailFeedbackItems: any = _.get(Helpers, 'brandDetails.detailed_feedback_items', null);
        let questionName = _.find(ratingTypeProp, (item: any) => item.value == keyName)?.label;
        if(!questionName && brandDetailFeedbackItems != null) {
          let filterdObject: any = brandDetailFeedbackItems.filter(item => item.field_id === keyName)[0];
          if(filterdObject?.question) {
            questionName = filterdObject?.question;
          } else {
            questionName = filterdObject?.text;
          }
        }
        rowObjName = questionName;
      }
    }
    return rowObjName;
  }

  private prepareTableFooter(): void {
    this.distributionTable.tableFooter = [];
    this.comapreWithTable.tableFooter = [];
    let tableFooter: any = [];
    const detailedFeedbackItems = _.find(Helpers?.brandDetails?.detailed_feedback_items, { field_id: this.compareDropdownFieldId });
    const result = _.get(this.tableFooterDataCache.detailed_rating_by_type, this.compareDropdownFieldId, null);
    let calculatedResult: any = {};
    if(detailedFeedbackItems?.type === 'rating') {
      calculatedResult = this.getResultForRatingType(result, detailedFeedbackItems?.main_rater_type, detailedFeedbackItems?.scale_rater_type, detailedFeedbackItems?.is_primary_rating);
      this.overallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterDataCache, detailedFeedbackItems);
      this.previousOverallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterPreviousCache, detailedFeedbackItems);
    } else if(detailedFeedbackItems?.type === 'single-select') {
      calculatedResult = this.getResultForSelectionBasedType(result, '', 'single-select');
      this.overallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterDataCache, detailedFeedbackItems);
      this.previousOverallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterPreviousCache, detailedFeedbackItems);
    } else if(detailedFeedbackItems?.type === 'multi-select') {
      calculatedResult = this.getResultForSelectionBasedType(result, this.tableFooterDataCache, 'multi-select');
      this.overallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterDataCache, detailedFeedbackItems);
      this.previousOverallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterPreviousCache, detailedFeedbackItems);
    } else if(detailedFeedbackItems?.type === 'text') {
      calculatedResult = this.getResultForTextType(this.tableFooterDataCache?.primary_rating_distribution);
      this.overallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterDataCache, detailedFeedbackItems);
      this.previousOverallTotal = this.computeOverallTotalFromFooterCache(this.tableFooterPreviousCache, detailedFeedbackItems);
    }
    const footerRow: any = {
      name: 'Total',
      ...calculatedResult,
    };
    this.attachFooterDeviationsFromOverallCache(footerRow, detailedFeedbackItems);
    tableFooter.push(footerRow);
    this.distributionTable.tableFooter = tableFooter;
    this.comapreWithTable.tableFooter = tableFooter;
    this.refreshComparisonTablesWithOverallTotals();
  }

  private attachFooterDeviationsFromOverallCache(footerRow: any, detailedFeedbackItems: any): void {
    if (!footerRow || !detailedFeedbackItems || !this.tableFooterDataCache) {
      return;
    }
    const syntheticBucket = {
      detailed_rating_by_type: this.tableFooterDataCache?.detailed_rating_by_type,
      primary_rating_distribution: this.tableFooterDataCache?.primary_rating_distribution,
      previous: {
        detailed_rating_by_type: this.tableFooterPreviousCache?.detailed_rating_by_type,
        primary_rating_distribution: this.tableFooterPreviousCache?.primary_rating_distribution,
      },
    };
    this.attachRowDeviationsFromComparisonBucket(footerRow, syntheticBucket, detailedFeedbackItems);
  }

  private refreshComparisonTablesWithOverallTotals(): void {
    if (this.lastDistributionSummaryCache) {
      this.prepareDistributionTable(this.lastDistributionSummaryCache);
    }
    if (this.lastCompareWithSummaryCache) {
      this.prepareCompareWithTable(this.lastCompareWithSummaryCache);
    }
  }

  private getResultForRatingType(data: any, mainRaterType: any, scalerRaterType: any, isPrimaryRating: boolean): any {
    let totalResponse: any = data?.doc_count || 0;
    let rating: any = 0;
    let totalTop: any = 0;
    let totalMid: any = 0;
    let totalBottom: any = 0;
    let sumOfPrimaryRating = 0;
    const category = this.responseAnalyticsService.getRatingBandsByRaterType(scalerRaterType);
    const ratingNumber = data?.rating_number || {};
    for (let key in ratingNumber) {
      const numberOfUsersRated = ratingNumber[key] || 0;
      if (category.bottom.includes(Number(key))) {
        totalBottom += numberOfUsersRated;
        sumOfPrimaryRating += numberOfUsersRated * Number(key);
      } else if (category?.mid && category?.mid.includes(Number(key))) {
        totalMid += numberOfUsersRated;
        sumOfPrimaryRating += numberOfUsersRated * Number(key);
      } else if (category.top.includes(Number(key))) {
        totalTop += numberOfUsersRated;
        sumOfPrimaryRating += numberOfUsersRated * Number(key);
      }
    }
    if(scalerRaterType == '0-10' || scalerRaterType == '1-5') {
      rating = totalResponse > 0 ? ((totalTop - totalBottom) / totalResponse) * 100 : 'N/A';
      if (rating !== 'N/A') {
        if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
          rating = Math.floor(rating);
        } else if (rating > 0 && rating % 1 === 0.5) {
          rating = Math.ceil(rating);
        } else {
          rating = Math.round(rating);
        }
      }
    } else {
      rating = totalResponse > 0 ? (sumOfPrimaryRating / totalResponse).toFixed(2) : 0;
    }
    let topPercentage = totalResponse > 0 ? ((totalTop/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalTop/totalResponse)*100) + '%' : ((totalTop/totalResponse)*100).toFixed(1) + '%' : '0%';
    let midPercentage = totalResponse > 0 ? ((totalMid/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalMid/totalResponse)*100) + '%' : ((totalMid/totalResponse)*100).toFixed(1) + '%' : '0%';
    let bottomPercentage = totalResponse > 0 ? ((totalBottom/totalResponse)*100).toFixed(1).endsWith('.0') ? Math.round((totalBottom/totalResponse)*100) + '%' : ((totalBottom/totalResponse)*100).toFixed(1) + '%' : '0%';
    let obj: any = {
      responses: this.responseAnalyticsService.formatNumber(totalResponse),
      rating: rating,
      weightage: totalResponse == 0 ? 0 : 100,
      top: this.responseAnalyticsService.formatNumber(totalTop),
      mid: this.responseAnalyticsService.formatNumber(totalMid),
      bottom: this.responseAnalyticsService.formatNumber(totalBottom),
      toppercent: topPercentage,
      midpercent: midPercentage,
      bottompercent: bottomPercentage,
    }
    return obj;
  }

  private getResultForSelectionBasedType(data: any, rawData: any, type: string): any {
    let totalResponse: any = data?.doc_count || 0;
    if(type === 'single-select') {
      let ratingNumber: any = data?.rating_number || {};
      let obj: any = {
        responses: this.responseAnalyticsService.formatNumber(totalResponse),
        weightage: totalResponse == 0 ? 0 : 100,
      }
      const props = _.get(_.find(Helpers.brandDetails?.detailed_feedback_items, (item) => item?.field_id === this.compareDropdownFieldId), 'prop', null);
      if(props) {
        for(let propKey in props) {
          obj[Number(propKey)] = this.responseAnalyticsService.formatNumber(ratingNumber[propKey] || 0);
        }
      }
      return obj;
    } else {
      let obj: any = {
        responses: this.responseAnalyticsService.formatNumber(totalResponse),
        weightage: totalResponse == 0 ? 0 : 100,
      }
      const textFieldIds: any = Helpers?.brandDetails?.detailed_feedback_items.filter(item => item?.group_id === this.compareDropdownFieldId).map(item => item.field_id);
      if(textFieldIds && textFieldIds.length > 0) {
        textFieldIds.forEach(item => {
          const possibleValues = Helpers?.brandDetails?.detailed_feedback_items.filter(id => id.field_id === item)[0]?.possible_values[0];
          obj[possibleValues] = this.responseAnalyticsService.formatNumber(rawData?.detailed_rating_by_type[item]?.rating_number[possibleValues] || 0);
        })
      }
      return obj;
    }
  }

  private getResultForTextType(data: any): any {
    let totalResponse: any = 0;
    let rating: any = 0;
    let totalTop: any = 0;
    let totalMid: any = 0;
    let totalBottom: any = 0;
    let sumOfPrimaryRating: any = 0;
    const detailedFeedbackItemsText = _.get(Helpers, 'brandDetails.detailed_feedback_items', []).filter(item => item?.field_id === "primary_rating")[0];
    let mainRaterType: any = detailedFeedbackItemsText?.scale_rater_type;
    if (mainRaterType) {
      const category = this.responseAnalyticsService.getRatingBandsByRaterType(mainRaterType);
      for (let key in data) {
        const numberOfUsersRated = data[key] || 0;
        if (category.bottom.includes(Number(key))) {
          totalBottom += numberOfUsersRated;
          sumOfPrimaryRating += numberOfUsersRated * Number(key);
        } else if (category?.mid && category?.mid.includes(Number(key))) {
          totalMid += numberOfUsersRated;
          sumOfPrimaryRating += numberOfUsersRated * Number(key);
        } else if (category.top.includes(Number(key))) {
          totalTop += numberOfUsersRated;
          sumOfPrimaryRating += numberOfUsersRated * Number(key);
        }
      }
    }
    totalResponse = (totalTop + totalMid + totalBottom) || 0;
    if (mainRaterType == 3 || mainRaterType == '0-10' || mainRaterType == '1-5') {
      rating = totalResponse > 0 ? ((totalTop - totalBottom) / totalResponse) * 100 : 'N/A';
      if (rating !== 'N/A') {
        if (rating < 0 && (rating % 1 === -0.5 || rating % 1 === 0.5)) {
          rating = Math.floor(rating);
        } else if (rating > 0 && rating % 1 === 0.5) {
          rating = Math.ceil(rating);
        } else {
          rating = Math.round(rating);
        }
      }
    } else {
      rating = totalResponse > 0 ? (sumOfPrimaryRating / totalResponse).toFixed(2) : 'N/A';
    }
    let topPercentage = totalResponse > 0 ? ((totalTop / totalResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((totalTop / totalResponse) * 100) + '%' : ((totalTop / totalResponse) * 100).toFixed(1) + '%' : '0%';
    let midPercentage = totalResponse > 0 ? ((totalMid / totalResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((totalMid / totalResponse) * 100) + '%' : ((totalMid / totalResponse) * 100).toFixed(1) + '%' : '0%';
    let bottomPercentage = totalResponse > 0 ? ((totalBottom / totalResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((totalBottom / totalResponse) * 100) + '%' : ((totalBottom / totalResponse) * 100).toFixed(1) + '%' : '0%';
    let obj: any = {
      responses: this.responseAnalyticsService.formatNumber(totalResponse),
      rating: rating,
      weightage: totalResponse == 0 ? 0 : 100,
      top: this.responseAnalyticsService.formatNumber(totalTop),
      mid: this.responseAnalyticsService.formatNumber(totalMid),
      bottom: this.responseAnalyticsService.formatNumber(totalBottom),
      toppercent: topPercentage,
      midpercent: midPercentage,
      bottompercent: bottomPercentage,
    }
    return obj;
  }

  private prepareCompareDropdown(): void {
    try {
      const detailedFeedbackItems = Helpers?.brandDetails?.detailed_feedback_items || [];
      const mainRaterType = _.get(Helpers, 'brandDetails.main_rater_type') || _.get(Helpers, 'brandDetails.scaler_rater_type') || null;
      if (detailedFeedbackItems.length > 0) {
        const isValidQuestion = (response: any) =>
        (response?.type === 'rating' || response?.type === 'single-select' || response?.type === 'multi-select' || (response?.type === 'text' && !response?.is_user_info)) &&
        !(response?.type === 'single-select' && response?.group_id) &&
        response?.conversation_type === 'question' &&
        (response?.is_displayed_on_dashboard || response?.is_display_on_dashboard);
        const filterItems = _.filter(detailedFeedbackItems, (response: any) => isValidQuestion(response) && !(response?.is_deleted));
        const primaryRatingItems = _.filter(filterItems, (response: any) => response?.is_primary_rating).map((response: any) => ({
          name: response?.question, field_id: response?.field_id, field_type: 'question', is_primary_rating: true, type: response?.type, isPrefix: true
        }));
        const commentsItems = _.filter(filterItems, (response: any) => response?.is_primary_comment).map((response: any) => ({
          name: response?.question, field_id: response?.field_id, field_type: 'question', is_primary_comment: true, question_ids: ['comments'], type: response?.type, isPrefix: true
        }));
        const otherItems = _.filter(filterItems, (response: any) => !response?.is_primary_rating && !response?.is_primary_comment).map((response: any) => ({
          name: response?.question, field_id: response?.field_id, field_type: 'question', type: response?.type, question_ids: response?.type === 'text' ? [response?.field_id] : null, isPrefix: true
        }));
        const compareDropdownAfterSorting = _.concat(
          primaryRatingItems,
          commentsItems,
          otherItems
        );
        const filteredData = compareDropdownAfterSorting.filter(item => !(!mainRaterType && item.type === "text"));
        this.compareDropdown.options = filteredData;
      }
    } catch (error) {
      console.error('Error preparing dropdown options:', error);
    }
  }

  private prepareCategoryDropdown(): void {
    const dropdownRawData: any = [];
    const hierarchyListFormBrand: any = Helpers?.brandDetails?.hierarchy_list;
    let hierarchyList: any = '';
    for(let key in hierarchyListFormBrand) {
      hierarchyList = hierarchyListFormBrand[key];
    }
    const hierarchyListAliasFromBrand: any = Helpers?.brandDetails?.hierarchy_list_alias;
    let hierarchyListAlias: any = '';
    let hierarchyListAliasValue: any = '';
    for(let key in hierarchyListAliasFromBrand) {
      hierarchyListAliasValue = hierarchyListAliasFromBrand[key]?.name;
      hierarchyListAlias = hierarchyListAliasFromBrand[key]?.values;
    }
    if(hierarchyList && hierarchyList.length > 0 && hierarchyListAliasValue && hierarchyListAliasValue.length > 0) {
      let currentLevel: any = Helpers?.hierarchyStack;
      if(currentLevel && currentLevel.length > 0 && Helpers?.hierarchyStack && Helpers?.hierarchyStack.length > 0) {
        currentLevel = Helpers?.hierarchyStack[Helpers?.hierarchyStack.length - 1];
      }
      if(currentLevel && Object.keys(currentLevel).length > 0) {
        let currentKey: any = currentLevel?.field_id.split('_')[2];
        let createFieldId: any = currentLevel?.field_id.split('_');
        let attachCurrentFieldId: any = createFieldId[0]+'_'+createFieldId[1]+'_';
        const showAccessLevel: any = hierarchyList.slice(Number(currentKey) + 1);
        showAccessLevel.forEach((data: any) => {
          currentKey++;
          dropdownRawData.push({name: data, field_id: attachCurrentFieldId + currentKey, field_type: 'hierarchy', category: 'Hierarchy'});
        })
      } else {
        hierarchyList.forEach((item, index) => {
          if(index > 0) {
            dropdownRawData.push({name: item, field_id: hierarchyListAlias[index], field_type: 'hierarchy', category: 'Hierarchy'});
          }
        })
      }
    }
    const brandFieldDefinitions: any = Helpers?.brandDetails?.field_definitions;
    const brandDetailFeedbackItem: any = Helpers?.brandDetails?.detailed_feedback_items;
    if(brandFieldDefinitions && brandFieldDefinitions.length > 0 && brandDetailFeedbackItem && brandDetailFeedbackItem.length > 0) {
      brandFieldDefinitions.forEach((fieldDefinition: any) => {
        if(fieldDefinition?.compare_filter || fieldDefinition?.field_type === 'response') {
          const nameBasedOnFieldId = _.find(brandDetailFeedbackItem, item => item.field_id === fieldDefinition?.field_id);
          dropdownRawData.push({name: nameBasedOnFieldId?.question || nameBasedOnFieldId?.text || fieldDefinition?.name || fieldDefinition?.text || fieldDefinition?.question || fieldDefinition?.label || fieldDefinition?.field_id, field_id: fieldDefinition?.field_id, field_type: fieldDefinition?.field_type ||  'tag', category: 'Cohorts'})
        }
      })
    }
    this.tabelDropdownRawData = dropdownRawData;
  }

  private prepareTableHeader(): void {
    this.distributionTable.tableHeader = [];
    this.comapreWithTable.tableHeader = [];
    let tableHeader: any = this.prepareTableHeaderInit();
    if( _.size(tableHeader) > 0) {
      if(this.selectedDistributionOption !== '') {
        this.distributionTable.tableHeader  = this.createTableHeader(this.selectedDistributionOption, tableHeader);
      }
      if(this.selectedCompareWithOption !== '') {
        this.comapreWithTable.tableHeader = this.createTableHeader(this.selectedCompareWithOption, tableHeader);
      }
    }
  }

  private createTableHeader(firstColumn: string, tableHeader: any): any {
    const metricColWidth = this.isComparisonAvailable ? '150px' : '120px';
    const metricColumn = (uniqueId: string, header: string, extra: Record<string, any> = {}) => ({
      uniqueId,
      header,
      width: metricColWidth,
      isSorting: true,
      style: { header: 'flex-end', row: 'flex-end' },
      ...extra,
    });
    const percentColumn = (uniqueId: string, header: string, image: string) => ({
      uniqueId,
      header,
      width: '120px',
      isSorting: true,
      isHeaderTextHide: true,
      image,
      style: { header: 'center', row: 'center' },
    });
    let tableHeaders: any = [
      { uniqueId: 'name', header: firstColumn, width: '210px', isSorting: true}
    ];
    if(tableHeader?.rating) {
      if(tableHeader?.top === 'Promoters') {
        tableHeaders.push(
          metricColumn('rating', tableHeader.display),
          metricColumn('responses', 'Responses'),
          metricColumn('weightage', 'Weightage (%)'),
          metricColumn('top', 'Promoters'),
          metricColumn('mid', 'Passives'),
          metricColumn('bottom', 'Detractors'),
          percentColumn('toppercent', 'Promoters (%)', 'assets/images/promoters.svg'),
          percentColumn('midpercent', 'Passives (%)', 'assets/images/passive.svg'),
          percentColumn('bottompercent', 'Detractors (%)', 'assets/images/detractors.svg'),
        )
      } else {
        if(tableHeader?.mid === '') {
          tableHeaders.push(
            metricColumn('rating', tableHeader.display),
            metricColumn('responses', 'Responses'),
            metricColumn('weightage', 'Weightage (%)'),
            metricColumn('top', tableHeader.top),
            metricColumn('bottom', tableHeader.bottom),
            { uniqueId: 'toppercent', header: `${tableHeader.top} (%)`, width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  },
            { uniqueId: 'bottompercent', header: `${tableHeader.bottom} (%)`, width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  },
          );
        } else {
          tableHeaders.push(
            metricColumn('rating', tableHeader.display),
            metricColumn('responses', 'Responses'),
            metricColumn('weightage', 'Weightage (%)'),
            metricColumn('top', tableHeader.top),
            metricColumn('mid', tableHeader.mid),
            metricColumn('bottom', tableHeader.bottom),
            { uniqueId: 'toppercent', header: `${tableHeader.top} (%)`, width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  },
            { uniqueId: 'midpercent', header: `${tableHeader.mid} (%)`, width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  },
            { uniqueId: 'bottompercent', header: `${tableHeader.bottom} (%)`, width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  },
          );
        }
      }
    } else {
      tableHeaders.push(
        metricColumn('responses', 'Responses'),
        metricColumn('weightage', 'Weightage (%)'),
      );
      _.forEach(tableHeader, (value, key) => {
        tableHeaders.push(metricColumn(String(key), value));
      });
    }
    return tableHeaders;
  }

  private prepareTableHeaderInit(): any {
    const detailedFeedbackItems = _.get(Helpers, 'brandDetails.detailed_feedback_items', []).filter(item => item?.field_id === this.compareDropdownFieldId)[0];
    if (_.size(detailedFeedbackItems) > 0) {
      if(detailedFeedbackItems.type === 'rating') {
        return this.getHeaderLabels(detailedFeedbackItems?.main_rater_type, detailedFeedbackItems?.scale_rater_type, detailedFeedbackItems?.is_primary_rating);
      } else if(detailedFeedbackItems.type === 'text') {
        const detailedFeedbackItemsText =  _.get(Helpers, 'brandDetails.detailed_feedback_items', []).filter(item => item?.field_id === "primary_rating")[0];
        return this.getHeaderLabels(detailedFeedbackItemsText?.main_rater_type, detailedFeedbackItemsText?.scale_rater_type, true);
      } else {
        let prop: any = detailedFeedbackItems?.prop;
        let header: any = {};
        if( _.size(prop) > 0) {
          _.forEach(prop, (value) => {
            header[value.value] = value.label;
          })
        }
        return header;
      }
    }
  }

  private getHeaderLabels(mainRaterType: string | number, scalerRaterType: string | number, isPrimaryRating: boolean): any {
    if (mainRaterType === undefined && scalerRaterType === undefined) {
        return;
    }
    let npsDisplayName: string = _.get(Helpers, 'brandDetails.label_configs.NPS.value', 'NPS');
    if(!npsDisplayName) {
      npsDisplayName = 'NPS';
    }
    const obj = { top: '', mid: '', bottom: '', rating: 'Rating', display: 'Rating' };
    const mapRaterTypeToLabels = {
      '0-10': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
      '1-5': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
      '1-10': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
      '7': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '5': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '9': { top: 'TB', mid: 'MB', bottom: 'BB' },
      '-5 to 5': { top: 'Positive', mid: '', bottom: 'Negative' },
      '-5 to +5': { top: 'Positive', mid: '', bottom: 'Negative' },
      '8': { top: isPrimaryRating ? 'T3B' : 'Positive', mid: isPrimaryRating ? 'MB' : '', bottom: isPrimaryRating ? 'B3B' : 'Negative' }
    };
    const raterTypeKey = mainRaterType !== undefined ? mainRaterType.toString() : null;
    const scalerTypeKey = scalerRaterType !== undefined ? scalerRaterType.toString() : null;
    const labels = (scalerTypeKey && mapRaterTypeToLabels[scalerTypeKey]) || null;
    return labels ? { ...obj, ...labels } : obj;
  }

  private getGroupAliasKey(): any {
    const hierarchyStack = _.get(Helpers, 'hierarchyStack', null);
    if(hierarchyStack) {
      const currentLevel = hierarchyStack[hierarchyStack.length - 1]?.field_id;
      if (currentLevel) {
        const hierarchyListAlias = _.get(Helpers, 'brandDetails.hierarchy_list_alias', {});
        const alias = _.find(hierarchyListAlias, (item: any) => item?.values?.includes(currentLevel));
        if (alias) {
          const values = alias?.values;
          const nextLevelIndex = values.indexOf(currentLevel) + 1;
          return values[nextLevelIndex] || null;
        }
      }
    } else {
      const hierarchyFilterMapping =  Helpers?.hierarchyFilterMapping;
      return hierarchyFilterMapping[2]?.key;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onDownload(): void {
    if(!this.distributionSearchPlaceHolder) {
      this.toastService.showToast('WARN', '', 'Please select an option from the Compare dropdown followed by a Distribution.', 1500);
      return;
    }
    if(this.downloadThroughAPIDistribution || this.downloadThroughAPICompareWith) {
      let payload: any = {
        "brand_id": Helpers?.brandDetails?._id,
        "field_id": this.compareWithSearchPlaceHolder ? this.compareWithFieldId : this.distributionFieldId,
        "field_type": this.compareWithSearchPlaceHolder ? this.compareWithFieldType : this.distributionFieldType,
        "api_url": environment.host + '/v1/litmus_analytics/comparison',
        "question_id": this.compareDropdownFieldId,
        "report_name": `Comparison - ${this.distributionSearchPlaceHolder}, ${this.compareWithSearchPlaceHolder}`,
        "parameters": [
            {
                "manager_type": 2,
                "brand_id": Helpers?.brandDetails?._id,
                "main_rater_type": Helpers?.brandDetails?.main_rater_type,
                "shop_id_list": [],
                "from": Helpers?.datePicker.startDate,
                "to": Helpers?.datePicker.endDate,
                "view_type": "overall",
                "field_id": "overall",
                "field_type": "overall",
                "question_aggs": true,
                "is_custom_date_range_selected": Helpers?.datePicker.isCustomDateRangeSelected,
                "date_filter_type": Helpers?.datePicker.dateFilterType,
                "data": {
                    "showImportance": true,
                    "overallCount": this.overallTotal
                }
            },
            {
                "manager_type": 2,
                "brand_id": Helpers?.brandDetails?._id,
                "main_rater_type": Helpers?.brandDetails?.main_rater_type,
                "shop_id_list": [],
                "from": Helpers?.datePicker.startDate,
                "to": Helpers?.datePicker.endDate,
                "view_type": "list",
                "field_id": this.distributionFieldId,
                "field_type": this.distributionFieldType,
                "question_aggs": true,
                "is_custom_date_range_selected": Helpers?.datePicker.isCustomDateRangeSelected,
                "date_filter_type": Helpers?.datePicker.dateFilterType,
                "size": 100,
                "data": {
                    "showImportance": true,
                    "overallCount": this.overallTotal
                }
            },
        ],
        "search_possible_values": true
      };
      if(this.compareWithSearchPlaceHolder) {
        payload.parameters.push({
          "manager_type": 2,
          "brand_id": Helpers?.brandDetails?._id,
          "main_rater_type": Helpers?.brandDetails?.main_rater_type,
          "shop_id_list": [],
          "from": Helpers?.datePicker.startDate,
          "to": Helpers?.datePicker.endDate,
          "view_type": "list",
          "field_id": this.compareWithFieldId,
          "field_type": this.compareWithFieldType,
          "question_aggs": true,
          "is_custom_date_range_selected": Helpers?.datePicker.isCustomDateRangeSelected,
          "date_filter_type": Helpers?.datePicker.dateFilterType,
          "size": 100,
          "data": {
            "showImportance": true,
            "overallCount": this.overallTotal
          }
        })
      }
      this.responseAnalyticsService.createDashboardReportingJob(payload);
    } else {
      let tableInfo: any = this.prepareTableInfoToCSV();
      let distributionTableData: any = this.generateCSV(this.distributionTable?.tableHeader, this.distributionTable?.tableRow, this.distributionTable?.tableFooter);
      let comapreWithTableData: any = '';
      if(this.compareWithSearchPlaceHolder) {
        comapreWithTableData = this.generateCSV(this.comapreWithTable?.tableHeader, this.comapreWithTable?.tableRow, this.comapreWithTable?.tableFooter);
      }
      let combinedCSV = tableInfo + '\n\n' + distributionTableData + '\n\n' + comapreWithTableData;
      this.sendReportForDownload(combinedCSV);
    }
  }

  prepareTableInfoToCSV() {
    let obj = {
      'Report name :': `Score Comparison - ${this.distributionSearchPlaceHolder}${this.compareWithSearchPlaceHolder ? `, ${this.compareWithSearchPlaceHolder}` : ''}`,
      'Report Date :': `${moment(Helpers?.datePicker?.formatedStartDate, "DD MMM' YY").format('DD-MMM-YYYY')} - ${moment(Helpers?.datePicker?.formatedEndDate, "DD MMM' YY").format('DD-MMM-YYYY')}`,
      'For Account :': Helpers?.accountDetails?.display_name || Helpers?.accountDetails?.name,
      'For Project :': Helpers?.brandDetails?.display_name || Helpers?.brandDetails?.name,
      'Interaction :': this.selectedOption,
      'Downloaded On :': moment().format('DD-MMM-YYYY hh:mm:ss a'),
      'Downloaded By :': Helpers?.managerDetails?.manager?.email_address
    };
    const rows = Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string' && (value.includes(',') || value.includes('\n') || value.includes('"'))) {
        value = `"${value.replace(/"/g, '""')}"`;
      }
      return `${key},${value}`;
    });
    const csv = rows.join('\n');
    return csv;
  }

  generateCSV(header, row, footer) {
    const wrapInQuotes = (value) => {
      if (typeof value === 'string') {
        if (value.includes('"')) {
          value = `"${value.replace(/"/g, '""')}"`;
        } else if (value.includes(',') || value.includes('\n')) {
          value = `"${value}"`;
        }
      }
      return value;
    };
    const headerRow = header.map(col => wrapInQuotes(col.header)).join(',');
    const dataRows = row.map(r =>
      header.map(col => wrapInQuotes(r[col.uniqueId])).join(',')
    ).join('\n');
    const dataFooter = footer.map(r =>
      header.map(col => wrapInQuotes(r[col.uniqueId])).join(',')
    ).join('\n');
    return `${headerRow}\n${dataRows}\n${dataFooter}`;
  }
  
  sendReportForDownload(processedFile: any): void {
    var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(processedFile);
    const downloadData = {
      _id: this.downloadService.getDownloadId(),
      filename: `Score Comparison - ${this.distributionSearchPlaceHolder}${this.compareWithSearchPlaceHolder ? `, ${this.compareWithSearchPlaceHolder}` : ''} ${moment().format('DD-MMM-YYYY')}`,
      orignal_filename: `Score Comparison - ${this.distributionSearchPlaceHolder}${this.compareWithSearchPlaceHolder ? `, ${this.compareWithSearchPlaceHolder}` : ''} ${moment().format('DD-MMM-YYYY')}` + ".csv",
      fileType: 'csv',
      dataSource: 'dashboard',
      progress: 100,
      uri: uri
    };
    this.downloadService.updateList(downloadData);
    this.downloadService.showDownloadSideBar(true);
  }

  private applyComparisonApiDateRange(payload: any): void {
    if (!payload) {
     return;
    }
    applyComparisonApiDateRange(
     payload,
     _.get(Helpers, 'datePicker', null)
    );
  }
}